import { render, staticRenderFns } from "./task.vue?vue&type=template&id=af7282b4&scoped=true"
import script from "./task.vue?vue&type=script&lang=js"
export * from "./task.vue?vue&type=script&lang=js"
import style0 from "../../../../node_modules/@riophae/vue-treeselect/dist/vue-treeselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./task.vue?vue&type=style&index=1&id=af7282b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af7282b4",
  null
  
)

export default component.exports